import React, { useCallback, useEffect, useMemo, useState } from "react";
import { makeStyles, Card, CardContent, Typography } from "@material-ui/core";
import classNames from "classnames";
import styles from "./Style.module.css";
import { getFixedValue } from "../../../../helper/helper";
import PageBoxComponent from "../../../../components/PageBox/PageBox.component";
import NoDataCard from "../../../Management/Dashboard/component/UserCard/NoDataCard";
const useStyles = makeStyles((theme) => ({
  customTooltip: {
    backgroundColor: "white",
    color: "black",
    fontSize: ".75rem",
    fontWeight: "normal",
    fontFamily: "Montserrat",
    borderRadius: "10px",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  card: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  mobileCard: {
    marginTop: theme.spacing(2),
  },
  mobileCardContent: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}));
const getCellStyles = (type) => {
  switch (type) {
    case "state_total":
      return { background: "#2896E9", color: "#ffffff" };
    case "zone_total":
      return { background: "#29CB97", color: "#ffffff" };
    case "closed_hq_total":
      return { background: "#F4881B", color: "#ffffff" };
    case "active_grand_total":
      return { background: "#2FA380", color: "#ffffff" };
    case "inactive_grand_total":
      return { background: "#FE4B4B", color: "#ffffff" };
    default:
      return { background: "#ffffff", color: "#161616" };
  }
};
const TableCell = ({
  row,
  key,
  fixed,
  readOnly,
  render,
  handleInputChange,
  name,
  value,
  isError,
  group,
  title,
  totalAvg,
  rating,
  index,
  ...props
}) => {
  return (
    <td
      key={key}
      style={{
        position: fixed ? "sticky" : "static",
        left: fixed ? getFixedValue(index) : undefined,
        padding: "20px 7px",
        ...getCellStyles(row?.type),
        fontSize: ".75rem",
        fontWeight: 500,
      }}
    >
      {render(row[key], row, index)}
    </td>
  );
};

const TableHead = ({ columns }) => {
  return (
    <thead>
      <tr>
        {columns?.map(({ key, parameters, label, fixed, text, is_static }) => (
          <>
            <th
              rowSpan={is_static ? 2 : 1}
              colSpan={parameters ? parameters.length : 1}
              key={key}
              style={{
                position: "sticky",
                left: fixed ? getFixedValue(key) : undefined,
                top: 0,
              }}
              className={styles.thead}
            >
              <div
                className={styles.tipWrap}
                style={{ width: fixed && "150px" }}
              >
                {label}
              </div>
            </th>
          </>
        ))}
      </tr>
    </thead>
  );
};
function HQTable({ currentData = [], title = "" }) {
  const classes = useStyles();
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setInnerWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const renderCardContent = () => {
    if (currentData?.length > 0) {
      return currentData?.map((row, index) => {
        return (
          <div>
            <Card
              key={row.id + "" + Math.random()}
              className={classNames(classes.mobileCard, "dtMobCard")}
            >
              <CardContent className={classes.mobileCardContent}>
                {renderTableCellsMobile(row, index)}
              </CardContent>
            </Card>
          </div>
        );
      });
    } else {
      return (
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6">No Results Found</Typography>
            <Typography variant="subtitle1">
              No matching entries available in our record
            </Typography>
          </CardContent>
        </Card>
      );
    }
  };

  const renderTableCellsMobile = (row, indexPr) => {
    const filteredColumns = tableStructure?.filter(
      (column) => column.is_mobile !== false
    );
    return filteredColumns.map((val, index) => (
      <div key={val?.key + "-" + index} className={"dtMobCell"}>
        <div className={"dtMobCellLabel"}>{val?.label}</div>
        <div className={"dtMobCellValueMultiple"}>
          {val?.render
            ? val?.render(row[val?.key], row, index)
            : (row[val?.key] ?? "-")}
        </div>
      </div>
    ));
  };

  const tableStructure = useMemo(() => {
    return [
      {
        key: "zone",
        label: "Zone",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.noWrapEmp}>{all?.zone}</div>
        ),
      },
      {
        key: "state",
        label: "State",
        sortable: false,
        render: (temp, all) => <div>{all?.state}</div>,
      },
      {
        key: "hq",
        label: "HQ",
        sortable: false,
        render: (temp, all) => <div>{all?.hq}</div>,
      },
      {
        key: "manpower_count",
        label: "Posted Manpower Count",
        sortable: false,
        render: (temp, all) => <div>{all?.manpower_count}</div>,
      },
      {
        key: "target",
        label: "Target",
        sortable: false,
        render: (temp, all) => <div>{all?.target}</div>,
      },
      {
        key: "achieved",
        label: "ACHIEVED",
        sortable: false,
        render: (temp, all) => <div>{all?.achieved}</div>,
      },
      {
        key: "achievement_pct",
        label: "ACHIEVEMENT %",
        sortable: false,
        render: (temp, all) => <div>{all?.achievement_pct}</div>,
      },
    ];
  }, [currentData, innerWidth]);

  return (
    <PageBoxComponent>
      <div className={styles.headerContainer}>
        <div>
          <span className={styles.title}>{title}</span>
          <div className={styles.newLine} />
        </div>
      </div>
      {innerWidth > 769 ? (
        <div style={{ width: "100%", marginBottom: "50px" }}>
          <div className={styles.tableWrapper}>
            <div className={styles.container}>
              <table
                style={{
                  borderCollapse: "collapse",
                  cellSpacing: "0",
                  borderSpacing: "0",
                  cellpadding: "0",
                  height: "100px",
                  width: "100%",
                }}
              >
                <TableHead columns={tableStructure} />
                <tbody>
                  {currentData?.length > 0 ? (
                    currentData.map((row, rowIndex) => (
                      <tr key={row.id} className={styles.tr}>
                        {tableStructure?.map(
                          (
                            { key, fixed, readOnly, render, ...props },
                            index
                          ) => (
                            <TableCell
                              row={row}
                              key={key}
                              fixed={fixed}
                              render={render}
                              index={index}
                              {...props}
                            />
                          )
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={tableStructure?.length}
                        style={{
                          textAlign: "center",
                          padding: "40px 0",
                        }}
                      >
                        <NoDataCard />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.paper}>{renderCardContent()}</div>
      )}
    </PageBoxComponent>
  );
}

export default HQTable;
